import React from 'react';
import { Button, Segment } from 'semantic-ui-react'
import MaskedInput from 'react-text-mask'
import MediaQuery from 'react-responsive'

import Usuarios from '../../services/Usuarios'
import InscricaoExterno from './InscricaoExterno'
import Mensagem from '../Sistema/Mensagem'
import IsDevIndicator from '../Ambiente/IsDevIndicator'
import Helper from '../Sistema/Helper'
import Mensagens from '../../Mensagens'

class Login extends React.Component {

    usernameField = null
    emailField = null
    selectField = null
    constructor(props) {
        super(props)

        this.state = {
            username: '',
            password: '',
            email: '',
            loading: false,
            message: '',
            usernameError: false,
            passwordError: false,
            emailError: false,
            loginOptions: props.loginOptions,
            loginOption: 0,
            user: undefined,
            icExibeCPF: false
        }
    }
    componentDidMount() {
        this.setState({
            ...this.state,
            loginOption: this.props.loginParameters.loginOption ? this.props.loginParameters.loginOption : this.props.loginParameters.loginOptions.length === 1 ? 1 : 0
        })

    }

    render() {

        const reminder = <span>*</span>
        const errorClass = 'act'
        const icCadastro = this.props.loginParameters.loginOption === 4

        const inputUsername = <input ref={(c) => this.usernameField = c}
            placeholder={this.props.loginParameters.loginOption === 1 ? Mensagens.p2 : Mensagens.p3}
            value={this.state.username}
            type='text'
            onBlur={(e) => this.onLostFocus('username', e.target.value)}
            onChange={(e) => this.onTextChanged('username', e.target.value)} />
        const inputPassword = <input fluid='true'
            placeholder={Mensagens.p4}
            value={this.state.password}
            type='password'
            onBlur={(e) => this.onLostFocus('password', e.target.value)}
            onChange={(e) => this.onTextChanged('password', e.target.value)} />
        const maskedCPF = <MaskedInput mask={[/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/,]}
            type='text'
            fluid='true'
            size='14'
            placeholder={Mensagens.p5}
            guide={true}
            ref={(c) => this.usernameField = c}
            onBlur={(e) => this.onLostFocus('cpf', e.target.value)}
            onChange={(e) => this.onTextChanged('username', e.target.value)}
            value={this.state.username} />
        const inputEmail = <input fluid='true' ref={(c) => this.emailField = c}
            placeholder={Mensagens.p6}
            value={this.state.email}
            type='email'
            onBlur={(e) => this.onLostFocus('email', e.target.value)}
            onChange={(e) => this.onTextChanged('email', e.target.value)} />

        return <div className='container'>

            <h2 className="title">{this.props.loginParameters.loginTitle}{this.props.loginParameters.evento && <span>: {this.props.loginParameters.evento.deTituloEvento}</span>}</h2>
            <h5>{Mensagens.m1}</h5>

            {(this.props.loginParameters.loginMessage || this.props.loginParameters.loginMessageList.length > 0) &&
                <Mensagem
                    error
                    Header={Mensagens.m53}
                    Content={this.props.loginParameters.loginMessage}
                    list={this.props.loginParameters.loginMessageList} />
            }

            {Helper.isDevEnvironment() &&
                <Segment raised className='resetCorners resetBorders'  >
                    <IsDevIndicator ribbon content={Mensagens.m3} ></IsDevIndicator>
                    <p>{Mensagens.m2}</p>
                </Segment>
            }
            {icCadastro &&

                <InscricaoExterno
                    options={this.props.cadastroOptions}
                    onLogin={(u, p, o, c) => this.props.onLogin(u, p, o, c)}
                    onCancel={() => this.onVoltarInscricaoExterna()} />

            }

            {!icCadastro &&
                <Segment disabled={this.state.loading} loading={this.state.loading} className='resetBackground resetCorners resetBorders'  >

                    <div className='form'>
                        <div className='row'>
                            <div className='col'>
                                <select
                                    fluid='true' ref={(c) => this.selectField = c}
                                    placeholder={Mensagens.p1}
                                    onChange={(e) => this.onSelectChange('option', e.target.value)} >
                                    <option value=''  >{Mensagens.p1}</option>

                                    {(this.props.loginParameters.loginOptions && this.props.loginParameters.loginOptions.length > 0) && <option value={this.props.loginParameters.loginOptions[0].value}>{this.props.loginParameters.loginOptions[0].text}</option>}
                                    {(this.props.loginParameters.loginOptions && this.props.loginParameters.loginOptions.length > 1) && <option value={this.props.loginParameters.loginOptions[1].value}>{this.props.loginParameters.loginOptions[1].text}</option>}
                                    {(this.props.loginParameters.loginOptions && this.props.loginParameters.loginOptions.length > 2) && <option value={this.props.loginParameters.loginOptions[2].value}>{this.props.loginParameters.loginOptions[2].text}</option>}

                                </select>
                            </div>
                        </div>

                        {(this.state.loginOption === 1 || this.state.loginOption === 2) &&
                            <div>
                                <MediaQuery maxWidth={599}>
                                    <div className='boxMargin'>
                                        <div className={` col${this.state.usernameError ? errorClass : ''}`}>
                                            {inputUsername}
                                            {this.state.usernameError && reminder}
                                        </div>
                                        <div className={` col${this.state.passwordError ? errorClass : ''}`}>
                                            {inputPassword}
                                            {this.state.passwordError && reminder}
                                        </div>
                                    </div>
                                </MediaQuery>
                                <MediaQuery minWidth={600}>
                                    <div className='row boxMargin'>
                                        <div className={`col ${this.state.usernameError ? errorClass : ''}`}>
                                            {inputUsername}
                                            {this.state.usernameError && reminder}
                                        </div>
                                        <div className={`col ${this.state.passwordError ? errorClass : ''}`}>
                                            {inputPassword}
                                            {this.state.passwordError && reminder}
                                        </div>
                                    </div>
                                </MediaQuery>
                            </div>
                        }

                        {this.state.loginOption === 3 &&
                            <div>
                                <MediaQuery maxWidth={599}>
                                    <div className='boxMargin'>

                                        <div className={`col ${this.state.usernameError ? errorClass : ''}`}>
                                            {maskedCPF}
                                            {this.state.usernameError && reminder}
                                        </div>

                                        <div className={`col ${this.state.emailError ? errorClass : ''}`}>
                                            {inputEmail}
                                            {this.state.emailError && reminder}
                                        </div>
                                    </div>
                                </MediaQuery>
                                <MediaQuery minWidth={600}>
                                    <div className='row boxMargin'>

                                        <div className={`col ${this.state.usernameError ? errorClass : ''}`}>
                                            {maskedCPF}
                                            {this.state.usernameError && reminder}
                                        </div>

                                        <div className={`col ${this.state.emailError ? errorClass : ''}`}>
                                            {inputEmail}
                                            {this.state.emailError && reminder}
                                        </div>
                                    </div>
                                </MediaQuery>

                            </div>
                        }

                        {this.state.message &&
                            <Mensagem
                                error
                                Header={Mensagens.m36}
                                Content={this.state.message} />
                        }


                        {this.state.loginOption > 0 &&
                            <div style={{ textAlign: 'center' }} >
                                <MediaQuery minWidth={600}>
                                    {this.props.loginParameters.icPermiteCancelar &&
                                        <Button className='button type3' type='button' onClick={() => { this.onCancel() }}>{Mensagens.b2}</Button>}
                                    <Button className='button type2' type='button' onClick={() => this.onReset()} secondary>{Mensagens.b1}</Button>
                                </MediaQuery>


                                <Button className='button type1' type='button' onClick={() => this.onClick()} >{this.props.loginParameters.lblBtnLogin}</Button>

                                <MediaQuery maxWidth={599}>
                                    {this.props.loginParameters.icPermiteCancelar &&
                                        <Button className='button type3' type='button' onClick={() => { this.onCancel() }}>{Mensagens.b2}</Button>}
                                    <Button className='button type2' type='button' onClick={() => this.onReset()} secondary>{Mensagens.b1}</Button>
                                </MediaQuery>

                            </div>
                        }

                    </div>

                    
                </Segment>
            }

        </div>
    }

    onVoltarInscricaoExterna = () => {
        this.setState({
            ...this.state,
            loginOption: 0
        })
    }

    onCancel = () => {

        if (this.state.loginOption === 4) {

            this.setState({
                ...this.state,
                loginOption: 0
            })
            return;
        }
        ///quando ocorre algum erro de validação de eventos no login, porém o usuário foi autenticado, vamos reaproveitar o usuário logado
        if (this.state.user)
            Usuarios.setCurrentUser(this.state.user)

        if (this.props.onCancel)
            this.props.onCancel()
    }

    onSelectChange = (name, value) => {

        this.setState({
            ...this.state,
            usernameError: false,
            passwordError: false,
        }, () => {
            this.setState({
                ...this.state,
                loginOption: parseInt(value)
            })
        })
    }
    onTextChanged = (name, value) => {


        this.setState({
            ...this.state,
            [name]: value
        })
    }
    onLostFocus = (name, value) => {
        this.setValidationError(name, value)
    }

    setValidationError(name, value) {

        let condicao = value === ''
            || (name === 'cpf' && value.includes('_'))
            || (name === 'email' && (!value.includes('@') || !value.includes('.') || value.endsWith('.')))


        if (name === 'cpf')
            name = 'username'

        return new Promise((resolve, reject) => {
            this.setState({
                ...this.state,
                [`${name}Error`]: condicao
            }, () => resolve())
        })
    }

    onClick = () => {

        this.setValidationError('username', this.state.username).then(x => {

            if (this.state.loginOption === 3) //externo
                this.setValidationError('email', this.state.email).then(x => this.validarLogin())
            else
                this.setValidationError('password', this.state.password).then(x => this.validarLogin())
        })
    }

    validarLogin = () => {
        let icValido = !this.state.usernameError && !this.state.passwordError && !this.state.emailError

        this.setState({
            ...this.state,
            loading: icValido

        }, () => {
            if (icValido) {
                if (this.props.onLogin) {

                    this.props.onLogin(this.state.username, this.state.loginOption === 3 ? this.state.email : this.state.password, this.state.loginOption).then(result => {

                        this.setState({ message: result.Mensagem, loading: false })
                    })
                }
            }

        })
    }
    onReset = () => {

        this.setState({
            ...this.state,
            username: '',
            password: '',
            email: '',
            usernameError: false,
            passwordError: false,
            icExibeCPF: false
        })

    }
}

export default Login


// WEBPACK FOOTER //
// ./src/components/Usuarios/Login.js